import React from 'react'

import { ICheckboxProps } from 'core-components/library/checkbox/Checkbox'
import { OnboardingCheckbox } from 'onboarding/components/ui/theme'

import styles from './CategoryCheckbox.module.scss'

export const CategoryCheckbox = (props: ICheckboxProps) => {
  return (
    <div className={styles.container}>
      <OnboardingCheckbox
        checked={props.checked}
        className={styles.checkboxWrapper}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      {props.label ? props.label : null}
    </div>
  )
}
